<template>
  <div>
    <base-header class="header pb-8 pt-5 pt-lg-8 d-flex align-items-center">
      <!-- Mask -->
      <span class="mask bg-gradient-warning opacity-8"></span>
      <!-- Header container -->
      <div class="container-fluid d-flex align-items-center">
        <div class="row">
          <div class="col-lg-7 col-md-10">
            <p class="text-white mt-3 mb-5">
              Aqui você poderá gerenciar e editar as informações do batch de
              startups. Para vincular startups ao batch ela já deverá ter criado
              uma conta e estar devidamente cadastrada.
            </p>
          </div>
        </div>
      </div>
    </base-header>

    <div class="container-fluid mt--8">
      <div class="row">
        <div class="col-xl-8">
          <card shadow type="secondary">
            <div slot="header" class="bg-white border-0">
              <div class="row align-items-center">
                <div class="col-12">
                  <h3 class="mb-0">
                    Batch <span class="text-warning">STARS</span>
                    <base-button
                      size="sm"
                      type="danger"
                      class="float-right"
                      @click="handleOpenModalremoveConfirmation"
                    >
                      <i class="fas fa-trash mr-1"></i> Deletar batch
                    </base-button>
                  </h3>
                </div>
              </div>
            </div>
            <template>
              <form
                @submit.prevent
                class="vld-parent"
                ref="form_edit_container"
              >
                <h6 class="heading-small text-muted mb-4">
                  Informações básicas
                </h6>
                <div class="pl-lg-4">
                  <div class="row">
                    <div class="col-lg-12">
                      <base-input label="Tipo">
                        <br />
                        <base-radio
                          name="Aceleração"
                          class="mb-3"
                          v-model="model.type"
                          :inline="true"
                        >
                          Aceleração
                        </base-radio>
                        <base-radio
                          name="Pré-aceleração"
                          class="mb-3"
                          v-model="model.type"
                          :inline="true"
                        >
                          Pré-aceleração
                        </base-radio>
                      </base-input>
                    </div>
                  </div>
                  <div class="row">
                    <div class="col-lg-6">
                      <div>
                        <base-input
                          label="Nome do batch"
                          v-model="model.name"
                          placeholder="Digite o nome"
                        />
                      </div>
                    </div>
                    <div class="col-lg-6">
                      <label class="form-control-label">
                        Status do batch
                        <i
                          v-if="model.status"
                          class="fas fa-info-circle ml-1"
                          :title="getStatusDescription"
                        ></i>
                      </label>
                      <div>
                        <base-input addon-left-icon="fas fa-cogs">
                          <select class="form-control" v-model="model.status">
                            <option selected disabled value="">
                              Selecione o status do batch
                            </option>
                            <option
                              v-for="status in batchStatus"
                              :key="status.key"
                              :value="status.key"
                            >
                              {{ status.value }}
                            </option>
                          </select>
                        </base-input>
                      </div>
                    </div>
                  </div>
                  <div class="row">
                    <div class="col-lg-6">
                      <label class="form-control-label">
                        Fundo de investimento
                        <base-button
                          v-if="model.fund_id"
                          type="link"
                          size="sm"
                          class="p-0 m-0 ml-2"
                          @click="
                            $router.push(
                              '/admin/fundos/' + model.fund_id + '/editar'
                            )
                          "
                        >
                          Ver fundo
                        </base-button>
                      </label>
                      <div class="vld-parent" ref="input_funds">
                        <base-input addon-left-icon="ni ni-tag">
                          <select
                            class="form-control"
                            v-model="model.fund_id"
                            @change="handleSelectFund"
                          >
                            <option selected disabled value="">
                              Selecione um fundo
                            </option>
                            <option
                              v-for="fund in funds"
                              :key="'fund_' + fund.id"
                              :value="fund.id"
                            >
                              {{ fund.tag }} - {{ getTypeLabel(fund.type) }}
                            </option>
                          </select>
                        </base-input>
                      </div>
                    </div>
                    <div class="col-lg-6">
                      <label class="form-control-label">
                        Chamada origem (opcional)
                        <base-button
                          v-if="model.startup_call_id"
                          type="link"
                          size="sm"
                          class="p-0 m-0 ml-2"
                          @click="
                            $router.push(
                              '/admin/chamadas/' +
                                model.startup_call_id +
                                '/editar'
                            )
                          "
                        >
                          Ver chamada
                        </base-button>
                      </label>
                      <div class="vld-parent" ref="input_calls">
                        <base-input addon-left-icon="ni ni-planet">
                          <select
                            class="form-control"
                            v-model="model.startup_call_id"
                          >
                            <option
                              v-if="model.fund_id && calls.length"
                              selected
                              value=""
                            >
                              Selecione uma chamada
                            </option>
                            <option
                              v-else-if="model.fund_id"
                              selected
                              disabled
                              value=""
                            >
                              Não há chamadas nesse fundo
                            </option>
                            <option v-else disabled selected value="">
                              ...
                            </option>
                            <option
                              v-for="call in calls"
                              :key="'call_' + call.id"
                              :value="call.id"
                            >
                              {{ call.name }} - Chamada de {{ call.type }}
                            </option>
                          </select>
                        </base-input>
                      </div>
                    </div>
                  </div>
                  <div class="row">
                    <div class="col-lg-6">
                      <label class="form-control-label"
                        >Data de início do batch</label
                      >
                      <base-input
                        type="date"
                        addon-left-icon="ni ni-calendar-grid-58"
                        placeholder="Data início"
                        input-classes="form-control"
                        v-model="model.start_date"
                      />
                    </div>
                    <div class="col-lg-6">
                      <label class="form-control-label"
                        >Data de fim do batch</label
                      >
                      <base-input
                        addon-left-icon="ni ni-calendar-grid-58"
                        type="date"
                        placeholder="Data fim"
                        input-classes="form-control"
                        v-model="model.end_date"
                      />
                    </div>
                  </div>
                  <div class="col-12">
                    <span class="duration">
                      {{ calcDuration() }}
                    </span>
                  </div>
                </div>
                <hr class="my-4" />
                <h6 class="heading-small text-muted mb-4">
                  Startups participantes do batch
                  <button
                    class="btn btn-sm btn-link"
                    @click="
                      $router.push(
                        `/admin/batches/${$route.params.id}/acompanhamento`
                      )
                    "
                  >
                    Acompanhar startups
                  </button>
                </h6>
                <div class="pl-lg-4 pl-md-0">
                  <div class="row">
                    <div class="col-sm-12 col-lg-8">
                      <div class="vld-parent" ref="input_startups">
                        <v-select
                          class="startup_select"
                          placeholder="Busque por uma startup (nome ou email)"
                          label="name"
                          :options="startups"
                          :filter-by="filterByNameOrEmail"
                          v-model="selectedStartup"
                          @input="handleSelectStartup"
                        >
                          <template v-slot:option="option">
                            <i class="fa fa-rocket mr-2"></i>
                            {{ option.name }}
                            <span class="float-right text-xs"
                              ><i class="fas fa-envelope mr-1"></i>
                              {{ option.user.email }}</span
                            >
                          </template>
                          <span slot="no-options">Não há startups</span>
                        </v-select>
                      </div>
                    </div>
                    <div
                      class="col-sm-6 offset-sm-3 offset-lg-0 col-lg-4 my-3 my-lg-0 text-center"
                    >
                      <base-button
                        :custom="true"
                        size="lg"
                        @click="handleAddStartup"
                        >Adicionar ao batch</base-button
                      >
                    </div>
                    <div class="col-12 text-right mt-2 text-muted">
                      Startups selecionadas até o momento:
                      <b>{{ selectedStartups.length }}</b>
                    </div>
                  </div>
                </div>
              </form>
            </template>
          </card>
        </div>
        <div
          class="col-xl-4 order-xl-1 mb-5 mb-xl-0 mt-5 mt-lg-0"
          v-if="selectedStartupInfo"
        >
          <div class="card text-center">
            <div class="card-profile-image">
              <img
                :src="selectedStartupInfo.logo.url"
                class="card-image my-4"
                alt="..."
              />
            </div>
            <div class="card-body mt-8 pt-0">
              <h2 class="card-title text-orange mb-1">
                {{ selectedStartupInfo.name }}
              </h2>
              <div>
                <div class="h5 font-weight-300 mb-1">
                  <i class="ni ni-pin-3 mr-2"></i
                  >{{ selectedStartupInfo.city || "..." }},
                  {{ selectedStartupInfo.state || "..." }}
                </div>
                <div>
                  <div class="h5 font-weight-300 mb-1">
                    <i class="fas fa-envelope mr-2"></i
                    >{{ selectedStartupInfo.user.email }}
                  </div>
                </div>
                <div class="h5 mt-2">
                  <badge type="info">
                    {{ selectedStartupInfo.sector }}
                  </badge>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="row mt-3">
        <div class="col-xl-8">
          <div v-if="!selectedStartups.length">
            <div class="row">
              <div class="col-12 text-center">
                <badge class="mt-2 bg-white" type="warning">
                  Nenhuma startup selecionada até o momento. Selecione-as a
                  partir da caixa de busca.
                </badge>
              </div>
            </div>
          </div>
          <div v-else class="card-deck vld-parent" ref="startups_list">
            <div
              class="col-md-6 col-xs-12 mt-5 d-flex align-items-stretch"
              v-for="startup in selectedStartups"
              :key="'selected_startups_' + startup.user_id"
            >
              <div class="card text-center flex-grow-1">
                <div class="card-profile-image">
                  <img
                    :src="startup.logo.url"
                    class="card-image my-4"
                    alt="..."
                  />
                </div>
                <div class="card-body mt-8 pt-0 pb-1">
                  <h2 class="card-title text-orange mb-1">
                    {{ startup.name }}
                  </h2>
                  <div>
                    <div class="h5 font-weight-300 mb-1">
                      <i class="ni ni-pin-3 mr-2"></i
                      >{{ startup.city || "..." }}, {{ startup.state || "..." }}
                    </div>
                    <div>
                      <div class="h5 font-weight-300 mb-1">
                        <i class="fas fa-envelope mr-2"></i
                        >{{ startup.user.email }}
                      </div>
                    </div>
                    <div class="h5 mt-2">
                      <badge type="info">
                        {{ startup.sector }}
                      </badge>
                    </div>
                  </div>
                </div>
                <div class="card-footer text-center">
                  <base-button
                    type="white"
                    icon="fas fa-trash text-red"
                    @click="handleRemoveStartup(startup.user_id)"
                  ></base-button>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="col-xl-8 mt-3 text-center">
          <base-alert type="danger" v-if="error" class="mb-4">{{
            error
          }}</base-alert>
          <base-button
            type="primary"
            :custom="true"
            size="lg"
            @click="handleSubmit()"
            :disabled="!isValidModel"
          >
            Salvar alterações
          </base-button>
        </div>
      </div>
    </div>
    <modal
      :show.sync="modals.removeConfirmation"
      gradient="dark"
      modal-classes="modal-danger modal-dialog-centered"
    >
      <h6 slot="header" class="modal-title" id="modal-title-notification">
        Atenção!
      </h6>
      <div class="vld-parent" ref="modal_confirmation_delete">
        <div class="py-3 text-center">
          <i class="fa fa-exclamation-circle fa-3x"></i>
          <h4 class="heading mt-4">
            Você realmente deseja excluir o batch
            <span class="text-danger">{{ model.name }}</span
            >?
          </h4>
          <p class="mt-3 mb-0">
            O batch perderá a relação com as startups cadastradas.
          </p>
          <p class="mt-3">
            Por favor, digite
            <span class="text-warning font-weight-bold">{{ model.name }}</span>
            para prosseguir
          </p>
          <base-input
            placeholder="Digite aqui"
            input-classes="form-control"
            addon-left-icon="fas fa-trash text-warning"
            v-model="modals.inputConfirmation"
          />
        </div>
        <div class="col-12 text-center" v-if="modals.removeError">
          <base-alert type="danger"
            >Ocorreu um erro ao remover o batch</base-alert
          >
        </div>
      </div>
      <template slot="footer">
        <base-button
          type="link"
          text-color="white"
          class="l-auto"
          @click="modals.removeConfirmation = false"
        >
          Voltar
        </base-button>
        <base-button
          type="white"
          class="text-danger"
          @click="handleDeleteBatch"
          :disabled="!inputConfirmationTextIsValid()"
        >
          Confirmar exclusão
        </base-button>
      </template>
    </modal>
  </div>
</template>
<script>
import api from "@/services/api.js";
import vSelect from "vue-select";
import "vue-select/dist/vue-select.css";

export default {
  name: "chamada",
  components: {
    "v-select": vSelect,
  },
  data() {
    return {
      model: {
        fund_id: "",
        startup_call_id: "",
        name: "",
        type: "",
        start_date: "",
        end_date: "",
        startups: [],
        status: "",
      },
      funds: [],
      calls: [],
      startups: [],
      filterByNameOrEmail: (option, label, search) => {
        const temp = search.toLowerCase();
        return (
          option.name.toLowerCase().indexOf(temp) > -1 ||
          option.user.email.toLowerCase().indexOf(temp) > -1
        );
      },
      selectedStartup: "",
      selectedStartupInfo: "",
      selectedStartups: [],
      error: "",
      batchStatus: [
        {
          key: "open",
          value: "Regular",
          description:
            "Um batch regular fica visível para os investidores cadastrados no fundo e para as startups inseridas no batch.",
        },
        {
          key: "closed",
          value: "Encerrado",
          description:
            "O status 'Encerrado' ficará visível para os investidores cadastrados no fundo e para as startups inseridas no batch.",
        },
        {
          key: "hidden",
          value: "Invisível",
          description:
            "Um batch invisível fica oculto para todos os investidores e startups.",
        },
      ],
      modals: {
        emptyFunds: false,
        emptyCalls: false,
        emptyStartupsCalls: false,
        removeConfirmation: false,
        inputConfirmation: "",
        removeError: false,
      },
    };
  },
  async mounted() {
    const loader = this.$loading.show({
      container: this.$refs.form_edit_container,
      width: 140,
      height: 140,
    });
    await this.loadBatch();
    await this.loadFunds();
    await this.loadStartups();
    loader.hide();
  },
  methods: {
    async loadData(
      endpoint,
      targetObjName,
      loaderRef,
      emptyModalRef,
      errorMsg
    ) {
      const loader = this.$loading.show({
        container: loaderRef,
        width: 90,
        height: 90,
      });
      try {
        const { data } = await api.get(endpoint);
        if (data.length) this[targetObjName] = data;
        else this.modals[emptyModalRef] = true;
        loader.hide();
      } catch (e) {
        this.$toasted.error(errorMsg);
      }
    },
    async loadBatch() {
      try {
        const { data } = await api.get(`/batches/${this.$route.params.id}`);
        Object.assign(this.model, data);
        this.handleSelectFund(); // load startup call (if it exist) of the stored fund
        const startupCallId = data.startup_call_id;
        this.model.startup_call_id = startupCallId || "";
      } catch (e) {
        this.$toasted.error("Error ao carregar informações do batch");
        this.$router.push("/");
      }
    },
    async loadFunds() {
      await this.loadData(
        "/funds",
        "funds",
        this.$refs.input_funds,
        "emptyFunds",
        "Ocorreu um erro ao recuperar os fundos"
      );
    },
    async loadStartups() {
      // load all startups
      await this.loadData(
        "/adm/startups",
        "startups",
        this.$refs.input_startups,
        "emptyStartups",
        "Ocorreu um erro ao recuperar as startups"
      );
      // fix logos
      const defaultLogoPath = "/img/pages/default_logo.png";
      this.startups.forEach((startup) => {
        if (!startup.logo) startup.logo = { url: defaultLogoPath };
      });
      // add batch_startups in the selected list
      this.model.startups.forEach((startup) => {
        this.swipeBetweenLists(
          this.startups,
          this.selectedStartups,
          startup.startup_id
        );
      });
    },
    async handleSelectFund() {
      this.model.startup_call_id = "";
      this.calls = [];
      await this.loadData(
        `/funds/${this.model.fund_id}/startup-calls`,
        "calls",
        this.$refs.input_calls,
        "emptyCalls",
        "Ocorreu um erro ao recuperar as chamadas de startups do fundo"
      );
    },
    handleSelectStartup() {
      this.selectedStartupInfo = this.selectedStartup;
    },
    handleAddStartup() {
      if (!this.selectedStartup) return;
      this.swipeBetweenLists(
        this.startups,
        this.selectedStartups,
        this.selectedStartup.user_id
      );
      this.selectedStartup = "";
      this.selectedStartupInfo = false;
    },
    handleRemoveStartup(id) {
      this.swipeBetweenLists(this.selectedStartups, this.startups, id);
    },
    swipeBetweenLists(source, target, startupId) {
      const index = source
        .map((startup) => {
          return startup.user_id;
        })
        .indexOf(startupId);
      if (index !== -1) target.push(...source.splice(index, 1));
    },
    async handleSubmit() {
      this.error = "";
      const loader = this.$loading.show({
        container: this.$refs.form_edit_container,
        width: 140,
        height: 140,
      });
      const startupsIds = this.selectedStartups.map(function (startup) {
        return startup.user_id;
      });
      this.model.startups = startupsIds;
      try {
        await api.put(`/batches/${this.$route.params.id}`, this.model);
        this.$toasted.show("Batch atualizado com sucesso");
        this.$router.push("/admin/batches");
      } catch (e) {
        this.error =
          "Ocorreu um erro ao atualizar o batch. Verifique as informações.";
        this.$toasted.error("Ocorreu um erro ao atualizar o batch");
      }
      loader.hide();
    },
    calcDuration() {
      if (this.model.start_date && this.model.end_date) {
        const d1 = this.moment(this.model.start_date);
        const d2 = this.moment(this.model.end_date);
        let diffDays = d2.diff(d1, "days");
        if (diffDays <= 0) return "Data fim deve ser maior que data de início";
        return `* Duração do batch: ${diffDays} dias`;
      }
    },
    getTypeLabel(fundType) {
      const separator = fundType === "Misto" ? "" : "de";
      return `Fundo ${separator} ${fundType}`;
    },
    handleOpenModalremoveConfirmation() {
      this.modals.removeConfirmation = true;
      this.modals.inputConfirmation = "";
    },
    inputConfirmationTextIsValid() {
      return this.modals.inputConfirmation === this.model.name;
    },
    async handleDeleteBatch() {
      this.modals.removeError = false;
      const loader = this.$loading.show({
        container: this.$refs.modal_confirmation_delete,
        width: 160,
        height: 160,
        opacity: 0,
      });
      try {
        await api.delete(`/batches/${this.$route.params.id}`);
        this.$toasted.show("Batch removido com sucesso");
        this.$router.push("/admin/batches");
      } catch (e) {
        this.error = "Ocorreu um erro ao remover o batch.";
        this.$toasted.error(this.error);
        this.modals.removeError = true;
      } finally {
        loader.hide();
      }
    },
  },
  computed: {
    getStatusDescription() {
      const selectedStatus = this.batchStatus.find(
        (status) => status.key === this.model.status
      );
      return selectedStatus ? selectedStatus.description : "";
    },
    isValidModel() {
      const data = this.model;
      if (this.selectedStartups.length <= 0) return false;
      for (const key in data) {
        if (data[key] === "" && key !== "startup_call_id") return false;
      }
      return true;
    },
  },
};
</script>
<style scoped>
.duration {
  text-transform: uppercase;
  font-size: 12px;
  color: #444444;
  font-family: inherit;
  font-weight: 600;
  line-height: 1.5;
}

.tag {
  font-family: inherit;
  font-weight: 600;
  line-height: 1.5;
  font-size: 18px;
  margin-left: 1em;
  color: black;
}

.tag-title {
  margin-bottom: 1.2em;
}

.card-image {
  width: 130px;
  height: 130px;
  border-radius: 10%;
  margin: auto;
}
</style>
<style>
.startup_select.v-select {
  background-color: #fff;
  background-clip: padding-box;
  border: 0.3px solid #cad1d7;
  border-radius: 0.375rem;
}
.startup_select.v-select .vs__dropdown-toggle {
  padding: 8px;
}
.startup_select.v-select
  .vs__dropdown-toggle
  .vs__selected-options
  .vs__search {
  color: #8898aa;
  line-height: 1.5;
  font-weight: 400;
}
</style>
